import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect } from "react";
import LocomotiveScroll from "locomotive-scroll";
import "locomotive-scroll/src/locomotive-scroll.scss";

gsap.registerPlugin(ScrollTrigger);

export default function useLocoScroll(start) {
  useEffect(() => {
    if (!start) return;
    let locoScroll = null; 
    const scrollEl = document.querySelector("#main-container");
    
    locoScroll = new LocomotiveScroll({
      el: scrollEl ?? undefined,
      smooth: true,
      multiplier: 1,
      class: "is-reveal",
    });

    locoScroll.on("scroll", () => {
      ScrollTrigger.update();
    });

    ScrollTrigger.scrollerProxy(scrollEl, {
      scrollTop(value) {
        if (locoScroll) {
          return arguments.length
            ? locoScroll.scrollTo(value, 0, 0)
            : locoScroll.scroll.instance.scroll.y;
        }
        return null;
      },
      scrollLeft(value) {
        if (locoScroll) {
          return arguments.length
            ? locoScroll.scrollTo(value, 0, 0)
            : locoScroll.scroll.instance.scroll.x;
        }
        return null;
      },
      pinType: scrollEl.style.transform ? "transform" : "fixed"
    }); 

    const lsUpdate = () => { 
      console.log("refreshed");
      if (locoScroll) {
        locoScroll.update();
      }
    };

    ScrollTrigger.defaults({
      scroller:scrollEl
    });


    ScrollTrigger.addEventListener("refresh", lsUpdate);
    ScrollTrigger.refresh();

    return () => {
      if (locoScroll) { 
        locoScroll.destroy(); 
        ScrollTrigger.removeEventListener("refresh", lsUpdate);
        // ScrollTrigger.kill();  
        locoScroll = null;
      }
    };
  }, [start]);
}
